import { cva, type VariantProps } from 'class-variance-authority';
import type { ReactNode } from 'react';
import { cn } from '@/shared/lib';

/**
 * Статус-пилюля (README §3 и §5, тоны TONE прототипа): фон тона, рамка и текст — цвет тона, точка.
 * sm — в таблице (19 / padding 0 6 / radius 9 / точка 5 / 10 500);
 * md — в шапке карточки (22 / padding 0 8 / radius 16 / точка 6 / 11 500).
 */
export const STATUS_TONES = ['ok', 'warn', 'bad', 'mute', 'gold'] as const;
export type StatusTone = (typeof STATUS_TONES)[number];

const pillVariants = cva('inline-flex shrink-0 items-center border whitespace-nowrap font-medium', {
  variants: {
    tone: {
      ok: 'border-tone-ok-fg bg-tone-ok-bg text-tone-ok-fg',
      warn: 'border-tone-warn-fg bg-tone-warn-bg text-tone-warn-fg',
      bad: 'border-tone-bad-fg bg-tone-bad-bg text-tone-bad-fg',
      mute: 'border-tone-mute-fg bg-tone-mute-bg text-tone-mute-fg',
      gold: 'border-tone-gold-fg bg-tone-gold-bg text-tone-gold-fg',
    },
    size: {
      sm: 'h-19 gap-5 rounded-9 px-6 text-[10px]',
      md: 'h-22 gap-6 rounded-16 px-8 text-[11px]',
    },
  },
  defaultVariants: { tone: 'mute', size: 'sm' },
});

export interface StatusPillProps extends VariantProps<typeof pillVariants> {
  children: ReactNode;
  className?: string;
}

export function StatusPill({ tone, size, children, className }: StatusPillProps) {
  return (
    <span className={cn(pillVariants({ tone, size }), className)}>
      <span
        aria-hidden="true"
        className={cn('shrink-0 rounded-pill bg-current', size === 'md' ? 'size-6' : 'size-5')}
      />
      {children}
    </span>
  );
}
